import styled from "styled-components";

export const Overlay = styled.div`
  z-index: ${({ theme }) => theme.zIndex.modal};
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.colors.overlay};
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media only screen and (min-width: 481px) {
    align-items: center;
  }
`;

export const Sheet = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.xl} ${({ theme }) => theme.radius.xl} 0 0;
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[5]} ${({ theme }) => theme.space[7]};
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.gray300};
    border-radius: 2px;
  }

  @media only screen and (min-width: 481px) {
    border-radius: ${({ theme }) => theme.radius.xl};
    max-width: 420px;
    padding: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[6]} ${({ theme }) => theme.space[7]};
  }
`;

export const DragHandle = styled.div`
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: ${({ theme }) => theme.colors.gray300};
  margin: 0 auto ${({ theme }) => theme.space[4]};

  @media only screen and (min-width: 481px) {
    display: none;
  }
`;

export const SheetTitle = styled.h2`
  font-size: ${({ theme }) => theme.fonts.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0 ${({ theme }) => theme.space[1]};
`;

export const SheetTag = styled.p`
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray500};
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0 ${({ theme }) => theme.space[5]};
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space[3]};
  padding: ${({ theme }) => theme.space[3]} 0;
  border-top: 1px solid ${({ theme }) => theme.colors.gray100};
`;

export const InfoIconBox = styled.div`
  width: 36px;
  height: 36px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.primaryBg};
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
`;

export const InfoLabel = styled.div`
  font-size: ${({ theme }) => theme.fonts.xs};
  color: ${({ theme }) => theme.colors.gray400};
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
`;

export const InfoValue = styled.div`
  font-size: ${({ theme }) => theme.fonts.base};
  color: ${({ theme }) => theme.colors.gray800};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
`;

export const InfoSub = styled.div`
  font-size: ${({ theme }) => theme.fonts.xs};
  color: ${({ theme }) => theme.colors.gray500};
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
`;

export const WeekdayGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[1]};
  margin-top: 2px;
`;

export const CenterRouteBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[3]};
  margin-top: ${({ theme }) => theme.space[5]};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fonts.sm};
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.primaryLight};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(33,63,154,0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const WeekdayBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space[1]} ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => theme.radius.sm};
  background: ${({ theme }) => theme.colors.successLighter};
  color: ${({ theme }) => theme.colors.success};
  font-size: ${({ theme }) => theme.fonts.xs};
  font-weight: 600;
`;
